<template>
  <div>
    <el-upload :class="{ readonly: !hasAdd }" :multiple="multiple" :file-list="formatFileList"
      :action="$apis.common.uploadUrl" :headers="headers" :accept="accept" :limit="limit" :before-upload="beforeUpload"
      :on-success="onSuccess" :on-exceed="onExceed" list-type="picture-card" v-bind="$attrs">
      <template #default>
        <i class="el-icon-plus"></i>
      </template>
      <template #file="{ file, index }">
        <el-progress :width="90" v-if="file.status === 'uploading'" type="circle" :percentage="file.percentage" />
        <div class="image" v-if="['uploading', 'success', 'ready'].includes(file.status)">
          <div class="del" v-if="!readonly" @click="onRemove(file, index)">
            <!-- <Icon name="icon-plus" class="plus"></Icon> -->
            <i class="el-icon-plus plus"></i>
          </div>
          <!-- <Icon name="icon-video" :size="40" v-if="videoType.includes(getFileType(file.url))"
            @click="previewMedia(index)"></Icon> -->
          <i class="el-icon-video" v-if="videoType.includes(getFileType(file.url))" @click="previewMedia(index)"></i>
          <el-image v-else :src="file.url" fit="cover" @click="previewMedia(index)" />
        </div>
      </template>
      <template #tip>
        <slot name="tip">
          <div v-if="!readonly" class="el-upload__tip">
            支持{{ accept }}的文件，单个文件不超过 {{ maxSize }}MB{{ multiple ? `，最多可上传${limit} 个文件` : '' }}
          </div>
          <div class="no-data" v-else-if="readonly && !formatFileList.length">
            <span>暂无内容</span>
          </div>
        </slot>
      </template>
    </el-upload>
    <template v-if="preview">
      <!-- <media-viewer v-if="showViewer" :initial-index="initialIndex" :url-list="urlList" :teleported="previewTeleported"
        @close="closeViewer"></media-viewer> -->
      <image-viewer :visible.sync="showViewer" :initial-index="initialIndex" :url-list="urlList"></image-viewer>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MediaUpload',
  props: {
    value: {
      type: [Array, String],
      default(rawProps) {
        return rawProps.multiple ? [] : ''
      }
    },
    accept: {
      type: String,
      default: '.jpg,.jpeg,.png,.gif,.svg'
      // ,.mp4,.avi,.mov视频文件
    },
    multiple: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 6
    },
    maxSize: {
      type: Number,
      default: 50
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      videoType: ['mp4', 'avi', 'mov'],
      headers: {},
      initialIndex: 0,
      showViewer: false
    }
  },
  computed: {
    formatFileList() {
      if (Array.isArray(this.value)) {
        return this.value.map(item => {
          return {
            name: item.fileName,
            url: item.filePrefix + item.fileUrl
          }
        })
      } else {
        console.log('this.sssssssssssssssss', this.value)
        if (this.value && URL.canParse(this.value)) {
          const location = new URL(this.value)
          return [{
            name: location.pathname.split('/').pop(),
            url: this.value
          }]
        } else {
          return []
        }
      }
    },
    preview() {
      return this.formatFileList.length > 0
    },
    urlList() {
      return this.formatFileList || []
    },
    hasAdd() {
      return (!this.readonly && this.multiple && this.formatFileList.length < this.limit) || (!this.multiple && this.formatFileList.length === 0)
    }
  },
  watch: {
  },
  methods: {
    previewMedia(index) {
      this.initialIndex = index
      this.showViewer = true
    },
    onRemove(file) {
      if (this.multiple) {
        const index = this.value.findIndex(item => item.fileName === file.name)
        this.value.splice(index, 1)
      } else {
        this.$emit('input', '')
      }
    },
    // 下载
    onDownload(file) {
      window.location.href = `${file.url}?download=1`
    },
    onSuccess(res, file, uploadFiles) {
      if (res.code === 200) {
        // 保证没有文件需要处理了在进行双向绑定，否则会造成文件列表紊乱
        if (uploadFiles.every(item => !['ready', 'uploading'].includes(item.status))) {
          uploadFiles.forEach(item => {
            if (item.response) {
              if (this.multiple) {
                this.value.push(item.response.data)
              } else {
                const data = item.response.data
                const url = data.filePrefix + data.fileUrl
                this.$emit('input', url)
              }
            }
          })
        }
      } else {
        const fileIndex = uploadFiles.findIndex(item => item.uid === file.uid)
        uploadFiles.splice(fileIndex, 1)
        this.$message({ type: 'error', message: '上传失败！！！' })
      }
    },
    onExceed(files) {
      this.$message({
        type: 'error',
        message: `本次选择${files.length}个，已超出最大上传个数，请重新选择`
      })
    },
    beforeUpload(file) {
      const fileType = this.getFileType(file.name)
      if (!this.accept.includes(fileType)) {
        this.$message({ type: 'error', message: `${file.name}文件格式错误` })
        return false
      }
      if (file.size > this.maxSize * 1024 * 1024) {
        this.$message({ type: 'error', message: `${file.name}超过文件的最大大小` })
        return false
      }
      return true
    },
    getFileType(name) {
      const suffix = name.substring(name.lastIndexOf('.') + 1)
      return suffix.toLowerCase()
    }
  }
}

</script>

<style lang="scss">
.el-form-item {
  &.is-error {
    .el-upload--picture-card {
      border-color: #F56C6C !important;
    }
  }
}
</style>

<style scoped lang="scss">
.el-progress {
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.7);
  z-index: 10;
  padding: 5px;
}

.image {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #e9f0ff;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-image {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .del {
    position: absolute;
    top: -20px;
    right: -20px;
    background-color: #F56C6C;
    width: 40px;
    height: 40px;
    transform: rotate(45deg);
    // border-top: 15px solid var(--el-color-danger);
    // border-right: 15px solid var(--el-color-danger);
    // border-bottom: 15px solid transparent;
    // border-left: 15px solid transparent;
    z-index: 10;

    &:hover {
      cursor: pointer;
      background-color: #ffaaaa;
    }

    .plus {
      position: absolute;
      left: 50%;
      font-size: 16px;
      color: #ffffff;
      top: 24px;
      transform: translate3d(-50%, 0, 0);
    }
  }
}

.readonly {
  display: flex;
  flex-direction: column;

  ::v-deep {
    .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}

.el-upload__tip {
  margin-top: 0;
}

.no-data {
  font-size: var(--el-font-size-base);
}
</style>
